import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faCaretRight } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import React, { useEffect, useState } from "react";
import styled from "styled-components";

export const RaksDrawerStyle = styled.div`
  .drawer > div {
    padding: 24px 0 24px 24px;
    border-right: none;
    background-color: transparent;
  }

  .icon-drawer {
    &:hover {
      cursor: pointer;
    }
  }
`;

export const DrawerContentStyle = styled.div`
  min-width: 704px;
  height: 100vh;
  background-color: transparent;
  display: grid;
  grid-template-columns: 32px auto;

  .btnAnuluj {
    height: 36px;
    background-color: ${(props) => props.theme.opacityMask8};
    border-radius: 6px 0 0 6px;
    align-items: center;
    display: grid;
    justify-content: center;
    cursor: pointer;

    .fa-icon {
      font-size: 36px;
      color: ${(props) => props.theme.palette.secondary.main};
    }
  }

  .window {
    padding: 8px 24px;
    background-color: ${(props) => props.theme.palette.background.default};
    box-shadow: -4px 0 5px 0 rgba(0, 0, 0, 0.07);
  }
`;

export interface DrawerProps {
  isOpen: boolean;
  content: string;
}

interface RaksDrawerProps {
  title?: string;
  btnLabel?: string;
  icon?: IconProp;
  children: any;
  isOpen?: boolean;
  onCancel?: Function;
  withExitEvent?: boolean;
}

const RaksDrawer = (props: RaksDrawerProps) => {
  const {
    title,
    btnLabel,
    icon,
    children,
    isOpen,
    onCancel,
    withExitEvent
  } = props;

  const [isExpanded, setIsExpanded] = useState(isOpen);
  const [beforeExit, setBeforeExit] = useState(false);

  useEffect(() => {
    setIsExpanded(isOpen);
  }, [isOpen]);

  const childrenWithProps = React.Children.map(children, (child) =>
    React.cloneElement(child, {
      closeDrawer: () => {
        setIsExpanded(false);
        setBeforeExit(false);
        onCancel && onCancel();
      },
      openedDrawer: isExpanded,
      beforeExit: beforeExit,
      blockExit: () => {
        setBeforeExit(false);
      }
    })
  );

  const handleClose = () => {
    if (withExitEvent) setBeforeExit(true);
    else {
      setIsExpanded(false);
      onCancel && onCancel();
    }
  };

  return (
    <RaksDrawerStyle>
      {icon && (
        <div className="icon-drawer" onClick={() => setIsExpanded(true)}>
          <FontAwesomeIcon className="fa-icon" icon={icon} />
        </div>
      )}
      {title && <div onClick={() => setIsExpanded(true)}>{title}</div>}
      {btnLabel && (
        <Button
          className="btn-drawer"
          onClick={() => setIsExpanded(true)}
          color="secondary"
          variant="contained"
        >
          {btnLabel}
        </Button>
      )}
      <Drawer
        className="drawer"
        anchor="right"
        open={isExpanded}
        onClose={handleClose}
      >
        <DrawerContentStyle>
          <div className="btnAnuluj" onClick={handleClose}>
            <FontAwesomeIcon
              className="fa-icon"
              icon={faCaretRight as IconProp}
            />
          </div>
          <div className="window">{childrenWithProps}</div>
        </DrawerContentStyle>
      </Drawer>
    </RaksDrawerStyle>
  );
};

export default RaksDrawer;
